declare global {
  interface Window {
    enableCueAnalyticsLogs: () => void;
    disableCueAnalyticsLogs: () => void;
    MathJax?: IMathJaxConfig;
    ReactNativeWebView?: IReactNativeWebview;
    ReactNativeTopInset: number;
    ReactNativeBottomInset: number;
    AppleID: IAppleIDAuth;
    google: IGoogleAccounts;
  }
}

// React & React DOM 42.80 kB
import 'regenerator-runtime/runtime';
import '@~/modules/sentry'; // 26.99 KB
import '@cuemath/comps/reset.css';
import './app.css';
import './typeform.css';

import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';

import { GTM_KEY } from '@~/constants/keys';
import analytics from '@~/modules/analytics'; // 40.61 KB
import { initializeAppleSDK } from '@~/modules/sdk-initializations/sdk-initializations';
import { setAppType, setPolyfills } from '@~/utils'; // 21.49 KB
import { getStudentServiceIdFromCookie } from '@~/utils/auth';

import App from './app'; // withour router - 96.91 KB, with router - 154.87 KB
import { initGlobalMethods } from './global';

setAppType();
setPolyfills();
initGlobalMethods();
initializeAppleSDK();

TagManager.initialize({
  gtmId: GTM_KEY,
});

const studentServiceId = getStudentServiceIdFromCookie();

// Remove the old analytics data
// TODO: Remove this after the release
localStorage.removeItem('CUEMATH_ANALYTICS');
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Root element with id 'root' not found");
}

const root = createRoot(rootElement);

if (studentServiceId) {
  analytics.login(studentServiceId, 'STUDENT');
}

root.render(<App />);
